import { RoutingUIError } from '../components/ErrorBoundary/RoutingUIError';
import { fetchWithAuth } from './fetchWithAuth';
import { getErrorMessage } from '../helpers/errorStatus';
import { RoutingReceipt } from '../types';

export type GetRoutingReceiptFromUrlParams = {
  accessToken: string;
  routingReceiptsUrl: string;
};

type RoutingReceiptResponse = {
  routingReceipts: RoutingReceipt[];
};

export const getRoutingReceiptsFromUrl = async ({
  accessToken,
  routingReceiptsUrl,
}: GetRoutingReceiptFromUrlParams) => {
  const response = await fetchWithAuth({ path: routingReceiptsUrl, accessToken });

  if (!response.ok) {
    if (response.status === 404) {
      // Receipts expire before decisions so it's entirely possible the receipt has expired already
      return undefined;
    }
    throw new RoutingUIError({
      name: 'ROUTING_RECEIPTS_ERROR',
      message: getErrorMessage({ erroredItem: 'routing receipts', statusCode: response.status }),
      link: { href: routingReceiptsUrl, name: 'Routing receipts link' },
    });
  }

  return ((await response.json()) as RoutingReceiptResponse).routingReceipts;
};
